const EmotionalSupportIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M47.7833 41.1641H39.1616"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.3049 39.0625H28.251"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.4764 41.1641H28.0308"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.2316 18.5781C53.0006 19.2095 53.6578 19.9881 54.1596 20.8849L57.7032 27.2128C59.288 30.0408 57.6757 33.5941 54.5044 34.2643L45.7791 36.1097C44.8354 36.3104 43.911 35.6953 43.7313 34.7483L43.6925 34.5411C43.5322 33.6993 44.0146 32.8673 44.824 32.5888L53.5186 29.6021C53.7549 29.5212 53.8456 29.2347 53.6983 29.0323L51.5064 25.9518"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.5065 24.3281C51.5065 24.3281 51.4802 28.2305 50.9268 30.4882"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.7633 24.3281C35.7633 24.3281 35.4805 27.5157 36.5327 30.1308"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.0638 39.0622C40.3758 38.9521 39.67 38.7822 38.9609 38.5312"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.7833 38.5312C47.7833 38.5312 46.8833 38.855 45.4846 39.0622"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.449 39.0625H61.9477C62.239 39.0625 62.5013 39.1807 62.6923 39.3701C62.8817 39.5611 62.9999 39.8233 62.9999 40.1147C62.9999 40.6959 62.5288 41.1669 61.9477 41.1669H53.449"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9883 39.0625H41.0636H45.4845H47.7832"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.43796 39.0625H2.05222C1.47107 39.0625 1 39.5336 1 40.1147C1 40.4061 1.11817 40.6684 1.30757 40.8594C1.49859 41.0488 1.76083 41.1669 2.05222 41.1669H7.61117"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.0779 34.7734C52.9002 35.3997 53.449 36.5377 53.449 37.8395V54.4182C53.449 56.3953 52.1799 58 50.6161 58C49.8342 58 49.1268 57.5988 48.6136 56.95C48.1005 56.3012 47.7832 55.4067 47.7832 54.4182V37.8395C47.7832 37.074 47.9726 36.3658 48.2964 35.7845"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8192 36.9922C38.6911 35.4329 37.3231 34.2727 35.7638 34.4008C34.2045 34.5289 33.0443 35.8969 33.1724 37.4562L34.6615 55.5767C34.7896 57.136 36.1576 58.2962 37.7169 58.1681C39.2762 58.0399 40.4364 56.672 40.3082 55.1127L38.8192 36.9922Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.41765 24.9766L7.5188 29.1935L14.2999 32.0718C14.9491 32.347 15.3376 32.9767 15.3376 33.6388C15.3376 33.8686 15.2907 34.1034 15.1903 34.3284C14.8487 35.0941 14.0005 35.4988 13.1895 35.2786L12.8026 35.1734"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2878 13.1431L22.7954 12.9618C24.9646 12.4551 27.2196 12.4503 29.3904 12.9472L39.5273 15.267"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8358 8.63281H42.3129C40.7745 8.63281 39.5273 9.87994 39.5273 11.4184V16.2076C39.5273 17.746 40.7745 18.9931 42.3129 18.9931H44.8358C46.3742 18.9931 47.6213 17.746 47.6213 16.2076V11.4184C47.6213 9.87994 46.3742 8.63281 44.8358 8.63281Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.30123 33.7504L5.48889 33.1855C3.39417 32.6157 2.31119 30.3008 3.21772 28.3275L5.78028 22.7458C7.51887 18.9595 10.5129 16.2427 14.4596 15.0156"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2257 39.0622C14.0508 39.0088 13.876 38.9521 13.7012 38.8906"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3357 41.1641H13.2947"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1233 39.0625H14.2257H21.9571H22.5544"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.73549 32.4399L9.73549 32.4399C11.2948 32.3117 12.6627 33.4719 12.7909 35.0312L14.4308 54.9881C14.559 56.5474 13.3988 57.9154 11.8395 58.0435L11.8395 58.0435C10.2801 58.1717 8.9122 57.0115 8.78407 55.4522L7.14412 35.4953C7.01598 33.9359 8.17618 32.568 9.73549 32.4399Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1113 32.2624L26.1113 32.2624C27.6675 32.4246 28.7975 33.8176 28.6353 35.3737L26.5394 55.4845C26.3772 57.0406 24.9842 58.1706 23.4281 58.0085L23.4281 58.0085C21.872 57.8463 20.7419 56.4533 20.9041 54.8972L23 34.7864C23.1622 33.2302 24.5552 32.1002 26.1113 32.2624Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1306 18.1827L27.3595 17.5262C26.8591 17.4887 26.4133 17.8409 26.3341 18.3365L24.9121 27.2287L24.9582 32.0976"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.8042 26.6008L34.0963 30.1929C34.0008 30.3775 34.1611 30.5912 34.3651 30.5523L42.9641 28.9076C43.0742 28.8866 43.1827 28.8769 43.2911 28.8769C44.1734 28.8769 44.9407 29.5616 45.0054 30.4795C45.0637 31.3196 44.5052 32.0805 43.6845 32.2747L33.6172 34.6689C31.0109 35.2889 28.7948 32.7021 29.8081 30.2221L33.2529 21.7865C34.3667 19.054 36.7578 17.402 39.6328 17.0312"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.96622 25.9844C8.96622 25.9844 8.74563 28.3308 9.72921 30.1365"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.854 5.56758L15.3839 6.08127C13.8777 6.39451 12.9107 7.86945 13.2239 9.37563L14.199 14.0645C14.5123 15.5707 15.9872 16.5378 17.4934 16.2246L19.9635 15.7109C21.4696 15.3976 22.4367 13.9227 22.1235 12.4165L21.1483 7.72761C20.8351 6.22142 19.3602 5.25434 17.854 5.56758Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.8192 15.1227L52.2146 17.1584C52.6088 17.4935 52.6568 18.0855 52.3218 18.4797L51.9595 18.906C51.3373 19.6381 50.2378 19.7273 49.5057 19.1051L48.3348 18.11C47.6027 17.4878 47.5135 16.3882 48.1357 15.6561L48.4979 15.2299C48.833 14.8357 49.425 14.7876 49.8192 15.1227Z"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.3054 41.1641V58.809"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.39941 41.1641V58.809"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmotionalSupportIcon;
